<template>
	<transition 
			appear
			:appear-active-class="$_sldGrpLyt_stylePageLayoutAnimation()">
		<v-row class="customVRow" align="center" no-gutters>
			<v-col>
				<v-slide-group
						class="pa-4"

						v-model="slideGroup_"

						:dark="$_sldGrpLyt_styleSlideGroupDark"
						:light="$_sldGrpLyt_styleSlideGroupLight"
						:next-icon="$_sldGrpLyt_styleSlideGroupNextIcon"
						:prev-icon="$_sldGrpLyt_styleSlideGroupPrevIcon"
						show-arrows>
					<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
						<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
							<v-slide-item
									:key="contentKey">
								<v-card class="ma-4 customVCard"
										:color="$_sldGrpLyt_styleCardColor"
										:dark="$_sldGrpLyt_styleCardDark"
										:elevation="$_sldGrpLyt_styleCardElevation"
										:flat="$_sldGrpLyt_styleCardFlat"
										:hover="$_sldGrpLyt_styleCardHover"
										:light="$_sldGrpLyt_styleCardLight"
										:outlined="$_sldGrpLyt_styleCardOutlined"
										:raised="$_sldGrpLyt_styleCardRaised"
										:tile="$_sldGrpLyt_styleCardTile">
									<template v-if="contentVals.title">
										<v-card-title>
											<v-row dense>
												<v-col>
													<span	class="title"
															v-html="$_sldGrpLyt_langContentTitle(contentVals)" />
												</v-col>
											</v-row>
										</v-card-title>
									</template>
									<template v-if="contentVals.image">
										<v-row>
											<v-col>
												<v-img	class="customVImg image_"
														cover 
														:src="$_sldGrpLyt_styleContentImageUrl(contentVals)" />
											</v-col>
										</v-row>
									</template>
									<template v-if="contentVals.subTitle">
										<v-card-title>
											<v-row dense>
												<v-col>
													<span	class="body-2"
															v-html="$_sldGrpLyt_langContentSubTitle(contentVals)" />
												</v-col>
											</v-row>
										</v-card-title>
									</template>
									<template v-if="contentVals.chips">
										<v-card-actions>
											<v-row dense>
												<template v-for="(chipVals, chipKey) in sortObject(contentVals.chips)">
													<v-col	:key="chipKey"
															cols="auto">
														<v-chip pill
																:color="$_sldGrpLyt_styleChipColor"
																:dark="$_sldGrpLyt_styleChipDark"
																:label="$_sldGrpLyt_styleChipLabel"
																:light="$_sldGrpLyt_styleChipLight"
																:outlined="$_sldGrpLyt_styleChipOutlined"
																:small="$_sldGrpLyt_styleChipSmall"
																:text-color="$_sldGrpLyt_styleChipTextColor">
															<v-avatar
																	left
																	:color="$_sldGrpLyt_getChanceColor(chipKey)">
																#
															</v-avatar>
															<span v-text="chipKey" />
														</v-chip>
													</v-col>
												</template>
											</v-row>
										</v-card-actions>
									</template>
									<template v-if="!isFalse($_sldGrpLyt_langContentText(contentVals))">
										<v-card-text>
											<v-row dense>
												<v-col>
													<span	class="markdown"
															v-html="marked($_sldGrpLyt_langContentText(contentVals))" />
												</v-col>
											</v-row>
										</v-card-text>
									</template>
									<template v-if="contentVals.actionButtons">
										<v-card-actions class="cardActions_">
											<v-row dense>
												<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
													<v-col :key="actionButtonKey" cols="auto">
														<v-btn	class="customVBtn"
																:block="$_sldGrpLyt_styleActionButtonBlock"
																:color="$_sldGrpLyt_styleActionButtonColor"
																:dark="$_sldGrpLyt_styleActionButtonDark"
																:depressed="$_sldGrpLyt_styleActionButtonDepressed"
																:elevation="$_sldGrpLyt_styleActionButtonElevation"
																:large="$_sldGrpLyt_styleActionButtonLarge"
																:light="$_sldGrpLyt_styleActionButtonLight"
																:outlined="$_sldGrpLyt_styleActionButtonOutlined"
																:rounded="$_sldGrpLyt_styleActionButtonRounded"
																:small="$_sldGrpLyt_styleActionButtonSmall"
																:text="$_sldGrpLyt_styleActionButtonFlat"
																@click="openLink(actionButtonVals.link)"
																v-text="$_sldGrpLyt_langActionButtonTitle(actionButtonVals)" />
													</v-col>
												</template>
											</v-row>
										</v-card-actions>
									</template>
								</v-card>
							</v-slide-item>
						</template>
					</template>
				</v-slide-group>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'SlideGroupLayout',
		props: {
			inits: Object,
			contents: Object
		},
		data() {
			return {
				isVideo_: false,

				colors_: {},

				slideGroup_: null
			}
		},
		computed: {
			// state
			$_sldGrpLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			// info
			$_sldGrpLyt_infoInterval() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.inits, 'interval')
			},
			// lang 
			// (content)
			$_sldGrpLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_sldGrpLyt_langContentSubTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.subTitle;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_sldGrpLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_sldGrpLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// style
			$_sldGrpLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_sldGrpLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_sldGrpLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_sldGrpLyt_styleSlideGroup() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'slideGroup')
			},
			$_sldGrpLyt_styleSlideGroupDark() {
				const self_ = this;
				const card_ = self_.$_sldGrpLyt_styleSlideGroup;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_sldGrpLyt_styleSlideGroupLight() {
				const self_ = this;
				const card_ = self_.$_sldGrpLyt_styleSlideGroup;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_sldGrpLyt_styleSlideGroupNextIcon() {
				const self_ = this;
				const card_ = self_.$_sldGrpLyt_styleSlideGroup;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.nextIcon)
			},
			$_sldGrpLyt_styleSlideGroupPrevIcon() {
				const self_ = this;
				const card_ = self_.$_sldGrpLyt_styleSlideGroup;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.prevIcon)
			},
			$_sldGrpLyt_styleCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'card')
			},
			$_sldGrpLyt_styleCardColor() {
				const self_ = this;
				const card_ = self_.$_sldGrpLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_sldGrpLyt_styleCardDark() {
				const self_ = this;
				const card_ = self_.$_sldGrpLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_sldGrpLyt_styleCardElevation() {
				const self_ = this;
				const card_ = self_.$_sldGrpLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_sldGrpLyt_styleCardFlat() {
				const self_ = this;
				const card_ = self_.$_sldGrpLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_sldGrpLyt_styleCardHover() {
				const self_ = this;
				const card_ = self_.$_sldGrpLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_sldGrpLyt_styleCardLight() {
				const self_ = this;
				const card_ = self_.$_sldGrpLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_sldGrpLyt_styleCardOutlined() {
				const self_ = this;
				const card_ = self_.$_sldGrpLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_sldGrpLyt_styleCardRaised() {
				const self_ = this;
				const card_ = self_.$_sldGrpLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_sldGrpLyt_styleCardTile() {
				const self_ = this;
				const card_ = self_.$_sldGrpLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_sldGrpLyt_styleActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'actionButton')
			},
			$_sldGrpLyt_styleActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_sldGrpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_sldGrpLyt_styleActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_sldGrpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_sldGrpLyt_styleActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_sldGrpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_sldGrpLyt_styleActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_sldGrpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_sldGrpLyt_styleActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_sldGrpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_sldGrpLyt_styleActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_sldGrpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_sldGrpLyt_styleActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_sldGrpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_sldGrpLyt_styleActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_sldGrpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_sldGrpLyt_styleActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_sldGrpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_sldGrpLyt_styleActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_sldGrpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_sldGrpLyt_styleActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_sldGrpLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			$_sldGrpLyt_styleChip() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'chip')
			},
			$_sldGrpLyt_styleChipColor() {
				const self_ = this;
				const chip_ =self_.$_sldGrpLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.color)
			},
			$_sldGrpLyt_styleChipDark() {
				const self_ = this;
				const chip_ = self_.$_sldGrpLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.dark)
			},
			$_sldGrpLyt_styleChipLabel() {
				const self_ = this;
				const chip_ = self_.$_sldGrpLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.label)
			},
			$_sldGrpLyt_styleChipLight() {
				const self_ = this;
				const chip_ = self_.$_sldGrpLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.light)
			},
			$_sldGrpLyt_styleChipOutlined() {
				const self_ = this;
				const chip_ = self_.$_sldGrpLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.outlined)
			},
			$_sldGrpLyt_styleChipSmall() {
				const self_ = this;
				const chip_ = self_.$_sldGrpLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.small)
			},
			$_sldGrpLyt_styleChipTextColor() {
				const self_ = this;
				const chip_ = self_.$_sldGrpLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.textColor)
			},
			// (content)
			$_sldGrpLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_sldGrpLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_sldGrpLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		},
		methods: {
			$_sldGrpLyt_getChanceColor(key) {
				const self_ = this;

				if(self_.colors_[key]) { return self_.colors_[key] }

				self_.colors_[key] = self_.getChanceColor()
				return self_.colors_[key]
			}
		}
	}
</script>

<style scoped>
	.row_ {
		margin-bottom: -24px;
	}
	.flat_.v-carousel {
		box-shadow: none;
	}
	.image_ {
		width: 250px;
	}
</style>
